import { hotjar } from 'react-hotjar';
import { HOTJAR_ID, HOTJAR_SNIPPET_VERSION } from 'settings';
import { IUser } from 'types/interfaces';

export enum enHotjarEvents {
  ORDERBUMP = 'orderbump'
}

interface IHotjarUser {
  id: number;
  email: string;
  name: string;
  belt?: string;
  isClubeBlack: boolean;
}

export class HotjarService {
  public init() {
    hotjar.initialize(HOTJAR_ID, HOTJAR_SNIPPET_VERSION);
  }

  public setUser(user: Omit<IUser, 'betaFeatures'>) {
    const hotjarUser: IHotjarUser = {
      id: user.id,
      email: user.email,
      name: user.name,
      belt: user?.belt,
      isClubeBlack: user?.isClubeBlack
    };

    hotjar.identify(String(user.id), hotjarUser);
  }

  public submitEvent(event: enHotjarEvents) {
    hotjar.event(event);
  }
}

const HotjarServiceFactory = () => new HotjarService();
const hotjarService = HotjarServiceFactory();

export default hotjarService;
